
// TODO: refactor into multiple inputs
// one for number, text, etc.
export default {
  name: 'FormInput',
  props: {
    item: {
      type: Object,
      required: true,
      key: {
        type: String,
        required: true
      },
      store: {
        type: String,
        required: true
      },
      name: {
        type: String
      },
      title: {
        type: String
      },
      value: {
        type: String
      },
      inputType: {
        type: String
      },
      unit: {
        type: String,
        required: false
      },
      renderAsLabelInside: {
        type: Boolean,
        default: false
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconname: {
      type: String
    },
    calculatedValue: {
      required: false
    },
    constraint: {
      required: false,
      type: Object,
      min: {
        type: String,
        required: false
      }
    }
  },
  data() {
    return {
      value: undefined,
      isValid: true,
      errors: [],
      currentTitle: `${this.item.title || this.$t(`attributes.${this.item.key}`)}${this.required ? ' *' : ''}`,
      labelTextHidden: true
    }
  },
  computed: {
    isNotALabelInside() {
      return !this.item.renderAsLabelInside
    },
    isALabelInside() {
      return this.item.renderAsLabelInside
    },
    isTextInputFilled() {
      return this.value !== undefined && this.value !== ''
    },
    inputValue() {
      return (this.isARadioButton && this.item.value) || false
    },
    inputMinValue() {
      return this.item?.constraint?.min || 0
    },
    isACheckbox() {
      return this.item.inputType === 'checkbox'
    },
    isARadioButton() {
      return this.item.inputType === 'radio'
    },
    iconName() {
      if (this.iconname) {
        return this.iconname
      }

      switch (this.item.key) {
        case 'email':
          return 'icon-email'
          break
        case 'password':
          return 'icon-password'
          break
        case 'passwordConfirmation':
          return 'icon-password'
          break
        case 'firstname':
          return 'icon-men'
          break
        case 'lastname':
          return 'icon-men'
          break
        default:
          return false
      }
    },
    type() {
      if (this.isACheckbox || this.isARadioButton) {
        this.labelTextHidden = false
        return this.item.inputType
      }

      if (this.item.inputType === 'number') {
        return 'number'
      }

      // https://developer.mozilla.org/de/docs/Web/HTML/Element/Input
      switch (this.item.key) {
        case 'email':
          return 'email'
          break
        case 'password':
          return 'password'
          break
        case 'passwordConfirmation':
          return 'password'
          break
        default:
          return 'text'
      }
    },
    name() {
      return this.item.name || this.item.key
    },
    autocomplete() {
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
      switch (this.item.key) {
        case 'email':
          return 'email'
          break
        case 'password':
          return 'current-password'
          break
        case 'name':
          return 'name'
          break
        default:
          return 'on'
      }
    }
  },
  created() {
    if (this.item.store) {
      this.value = this.$store.getters[`store__app__${this.item.store}/getInputValue`](this.item.key) || this.item.value
      this.writeToStore()
      return
    }

    if (this.item.value != undefined) {
      this.value = this.item.value
    }
  },
  watch: {
    value() {
      this.triggerChanges()
    },
    calculatedValue(newValue) {
      this.value = newValue
    }
  },
  methods: {
    checkValidity() {
      this.currentTimeoutID && window.clearTimeout(this.currentTimeoutID)

      this.currentTimeoutID = window.setTimeout(
        vueComponent => {
          if (vueComponent.$refs.input) {
            vueComponent.isValid = vueComponent.$refs.input.checkValidity()
            vueComponent.errors = vueComponent.$refs.input.validationMessage.split(',')
            this.$emit('checkFormValidity', this.$refs.input)
          }
        },
        250,
        this
      )
    },
    writeToStore() {
      if (this.item.store) {
        const data = { key: this.item.key, value: this.value }
        this.$store.dispatch(`store__app__${this.item.store}/setInputValue`, data)
      }
    },
    notifyForFormInputChange() {
      this.$emit('notifyForFormInputChange', this.$refs.input)
    },
    triggerChanges() {
      this.writeToStore()
      this.notifyForFormInputChange()
      this.checkValidity()
    }
  }
}
